import { BadgeModel, PropertyListingBadgeModel } from 'models';

import { LodgingPwaPropertySearch, PropertyFields } from '__generated__/api';

/**
 * Always return a model, but the fields can be null if there is no offerBadge
 */
const getPropertyListingBadgeModel = (property: LodgingPwaPropertySearch.PropertyInlineFragment): PropertyListingBadgeModel => {
  const offerBadge: PropertyFields.OfferBadge | null = property.offerBadge;

  return {
    primary: offerBadge && getBadge(offerBadge.primary),
    secondary: offerBadge && getBadge(offerBadge.secondary),
  };
};

/**
 * Return a null-safe badge model
 */
const getBadge = (badge): BadgeModel => ({
  text: badge && badge.text,
  theme: badge && badge.theme_temp,
  icon: badge && badge.icon_temp && badge.icon_temp.id,
  mark: badge && badge.mark && badge.mark.id,
});

export const BadgeAdapter = {
  getPropertyListingBadgeModel,
  getBadge,
};
